import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import axios from "axios";

const TimeLeftToNext = () => {
  const futureCycles = 140;
  const format = "ddd, MMM D, YYYY h:mm A";

  const [timetable, setTimetable] = useState([]);
  const [timeLeftToNextDay, setTimeLeftToNextDay] = useState("");

  const generateFutureCycles = useCallback(
    (initialExpiry, initialNextCycleType) => {
      let nextMomentMil = initialExpiry;
      let cycleType = initialNextCycleType;
      const cycles = [];

      for (let i = 0; i < futureCycles; i++) {
        if (i !== 0) {
          nextMomentMil +=
            cycleType === "day" ? 50 * 60 * 1000 : 100 * 60 * 1000;
        }
        const nextMoment = moment(nextMomentMil);
        cycles.push({
          type: cycleType,
          time: nextMoment.format(format),
        });
        cycleType = cycleType === "day" ? "night" : "day";
      }

      setTimetable(cycles);
    },
    [futureCycles, format]
  );

  useEffect(() => {
    axios
      .get("https://api.warframestat.us/pc/cetusCycle")
      .then((response) => {
        const data = response.data;
        const isDay = data.isDay;
        const expiryTime = moment(data.expiry).valueOf();
        generateFutureCycles(expiryTime, isDay ? "night" : "day");
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  }, [generateFutureCycles]);

  const updateTime = useCallback(() => {
    if (timetable.length > 0) {
      const nextDayCycle = timetable.find((cycle) => cycle.type === "day");
      if (nextDayCycle) {
        const nextDayMoment = moment(nextDayCycle.time, format);
        const timeDifference = nextDayMoment.diff(moment()); //check the time difference here

        if (timeDifference <= 0) {
          axios
            .get("https://api.warframestat.us/pc/cetusCycle")
            .then((response) => {
              const data = response.data;
              const isDay = data.isDay;
              const expiryTime = moment(data.expiry).valueOf();
              generateFutureCycles(expiryTime, isDay ? "night" : "day");
            })
            .catch((err) => {
              console.error("Error fetching data:", err);
            });
        } else {
          const countdown = moment.duration(timeDifference);
          setTimeLeftToNextDay(
            `
            ${countdown.hours() > 0 ? countdown.hours() + "h" : ""} 
            ${countdown.minutes() >= 0 ? countdown.minutes() + "m" : ""}
          `.trim()
          );
        }
      }
    }
  }, [timetable, generateFutureCycles]);

  useEffect(() => {
    const interval = setInterval(() => {
      updateTime();
    }, 1000);

    return () => clearInterval(interval);
  }, [updateTime]);

  useEffect(() => {
    if (!timeLeftToNextDay) {
      const interval = setInterval(() => {
        updateTime();
      }, 15000);

      return () => clearInterval(interval);
    }
  }, [timeLeftToNextDay, updateTime]);

  return <>{timeLeftToNextDay || "0m"}</>;
};

export default TimeLeftToNext;
